module.exports = __webpack_public_path__ + "static/media/meterBG.c5ae583b.svg";